export function routes($stateProvider) {
    $stateProvider
        .state('app.gas.relatorios', {
        url: '/relatorios',
        abstract: true
    })
        .state('app.gas.relatorios.carteira', {
        url: '/carteira?{user:int}&form:int}&{from:string}',
        title: 'Carteira',
        role: ['gasRelatorioList'],
        template: '<gas-carteira-view></gas-carteira-view>',
        params: {
            user: {
                dynamic: true
            },
        }
    })
        .state('app.gas.relatorios.recebimentos', {
        url: '/recebimentos?{from:string}&{to:string}',
        title: 'Recebimentos por Técnico',
        role: ['gasRelatorioList'],
        template: '<gas-recebimentos-view></gas-recebimentos-view>',
        params: {
            from: {
                dynamic: true
            },
            to: {
                dynamic: true
            }
        }
    })
        .state('app.gas.relatorios.mapafaturacao', {
        url: '/mapa-faturacao?{from:string}&{to:string}',
        title: 'Mapa Geral de Faturação',
        role: ['gasRelatorioList'],
        template: '<gas-mapa-faturacao-view></gas-mapa-faturacao-view>',
        params: {
            from: {
                dynamic: true
            },
            to: {
                dynamic: true
            }
        }
    })
        .state('app.gas.relatorios.faturacaoposterior', {
        url: '/faturacao-posterior?{from:string}&{to:string}',
        title: 'Faturação Posterior',
        role: ['gasRelatorioList'],
        template: '<gas-faturacao-posterior-view></gas-faturacao-posterior-view>',
        params: {
            from: {
                dynamic: true
            },
            to: {
                dynamic: true
            }
        }
    })
        .state('app.gas.relatorios.list', {
        url: '?{page:int}&{limit:int}&sortBy&filter',
        title: 'Relatórios',
        template: '<gas-relatorios-list-view></gas-relatorios-list-view>',
        role: ['gasRelatorioList'],
        params: {
            page: {
                value: 1,
                dynamic: true
            },
            limit: {
                value: 20,
                dynamic: true
            },
            sortBy: {
                array: true,
                dynamic: true
            },
            filter: {
                dynamic: true
            }
        }
    });
}
routes.$inject = ['$stateProvider'];
